module.exports = __webpack_public_path__ + "img/ic_no_job_history.ed6b1e5e.svg";